import { useWaitForTransactionReceipt, useWriteContract } from 'wagmi';
import { TransactionReceipt } from 'viem';

export const DEFAULT_CONFIRMATION_BLOCKS = 1;
export const DEFAULT_POLLING_INTERVAL = 2_000; // 2 seconds

export function useWriteContractWithReceipt(options?: {
  confirmations?: number;
  pollingInterval?: number;
}): {
  hash: `0x${string}` | undefined;
  writeError: Error | null;
  isWriteError: boolean;
  isWritePending: boolean;
  confirmError: Error | null;
  isConfirmLoading: boolean;
  isConfirmSuccess: boolean;
  isConfirmError: boolean;
  receipt: TransactionReceipt | undefined;
  writeContract: (params: unknown) => void;
  writeContractAsync: (params: unknown) => Promise<void>;
  reset: () => void;
} {
  const {
    data: hash,
    error: writeError,
    isError: isWriteError,
    isPending: isWritePending,
    writeContract,
    writeContractAsync,
    reset,
  } = useWriteContract();

  const {
    error: confirmError,
    isLoading: isConfirmLoading,
    isSuccess: isConfirmSuccess,
    isError: isConfirmError,
    data: receipt,
  } = useWaitForTransactionReceipt({
    hash,
    confirmations: options?.confirmations ?? DEFAULT_CONFIRMATION_BLOCKS,
    pollingInterval: options?.pollingInterval ?? DEFAULT_POLLING_INTERVAL,
  });

  return {
    hash,
    // write state
    writeError,
    isWriteError,
    isWritePending,
    // confirm state
    confirmError,
    isConfirmLoading,
    isConfirmSuccess,
    isConfirmError,
    // tx receipt
    receipt,
    // write function
    writeContract,
    writeContractAsync,
    reset,
  };
}
